import React from "react";
import "../assets/css/subhero.css";
import { Link } from "react-router-dom";

const SubHero = ({ name }) => {
  return (
    <>
      <div className="sub-hero-container">
        <h1>{name}</h1>
        <div className="sub-hero-bottom">
          <p>
            <Link to="/">Bootcamp</Link>
          </p>
          /
          <p>
            <Link to={`/${name}`}>{name}</Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default SubHero;
